<div class="title">{{ 'components.languageSwitcher.labels.title' | translate }}</div>

<div class="languages">
  <div *ngFor="let languageCode of languageCodes" class="language" (click)="selectLanguage(languageCode)">
    {{ getLanguage(languageCode) }}
    <app-icon
      *ngIf="isSelected(languageCode)"
      [src]="'@tui.check'"
      [size]="'24px'"
      [color]="'var(--tui-background-accent-1)'"
    ></app-icon>
  </div>
</div>
